<template>
  <div>
    <div class="topBanner">
      <div class="floatBox">
        <div class="floatLeft leftText">
          <img :src="leftLogo" @click="toPage(0)" class="leftIconImg" alt>
        </div>
        <div class="floatCenter">
          <div class="flexTwo">
            <div class="flexChild1" :class=" cur==0 ? 'active' : 'flexChild'" @click="toPage(0)">
              {{$t('menu.home')}}
              <div v-show="cur==0" class="bottomLine"></div>
              <div class="bottomLine1"></div>
            </div>
            <div class="flexChild2" :class="cur==1 ? 'active' : 'flexChild'" @click="toPage(1)">
              {{$t('menu.product')}}
              <div v-show="cur==1" class="bottomLine"></div>
              <div class="bottomLine2"></div>
            </div>
            <div class="flexChild3" :class="cur==2 ? 'active' : 'flexChild'" @click="toPage(2)">
              {{$t('menu.scheme')}}
              <div v-show="cur==2" class="bottomLine"></div>
              <div class="bottomLine3"></div>
            </div>

            <div class="flexChild4" :class="cur==3 ? 'active' : 'flexChild'" @click="toPage(3)">
              {{$t('menu.hardware')}}
              <div v-show="cur==3" class="bottomLine"></div>
              <div class="bottomLine4"></div>
            </div>
            <div class="flexChild5" :class="cur==4 ? 'active' : 'flexChild'" @click="toPage(4)">
              {{$t('menu.case')}}
              <div v-show="cur==4" class="bottomLine"></div>
              <div class="bottomLine5"></div>
            </div>
            <div class="flexChild6" :class="cur==5 ? 'active' : 'flexChild'" @click="toPage(5)">
              {{$t('menu.us')}}
              <div v-show="cur==5" class="bottomLine"></div>
              <div class="bottomLine6"></div>
            </div>
            <!-- <div  :class="cur==1 ? 'active' : 'flexChild'" >
              {{$t('menu.help')}}
              <div v-show='cur==1' class="bottomLine"></div>
            </div>-->
            <!-- <div class='flexChild flexChild7'>
              {{$t('menu.help')}}
              <div class="bottomLine7"></div>

            </div>-->
            <div class="flexChild8" :class=" cur== 6 ? 'active' : 'flexChild'" @click="toPage(6)">
              {{$t('menu.consult')}}
              <div v-show="cur== 6" class="bottomLine"></div>
              <div class="bottomLine8"></div>
            </div>
          </div>
        </div>
        <div class="floatRight">
          <div class="rightText" @click="toPageFun('https://sc.shutuo.tv/dsadm/login')">数拓后台</div>
          <div class="rightLast">
            <span class="CNCss" >CN</span>
            <span class="ENCss" >EN</span>
            <!-- <span class="CNCss" @click="tabCn">CN</span>
            <span class="ENCss" @click="tabEn">EN</span>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import leftLogo from "@/assets/images/leftLOGO.png";
import store from "../store.js";
export default {
  name: "Top",
  data() {
    return {
      defaultOpenKey: "",
      leftLogo: leftLogo,
      cur: store.state.tabCur,
      tabSet: [
        "/Home",
        "/Product",
        "/Plan",
        "/Hardware",
        "/SuccessCases",
        "/AboutShuoTuo",
        "/Information"
      ]
    };
  },
  mounted() {
    this.checkPath(this.$router.history.current.path);
  },
  methods: {
    toPageFun(val) {
      window.open(val, "_blank");
    },
    getSetIndex(val) {
      let tabSet = this.tabSet;
      console.log(1111111111, val);
      let idx = 0;
      for (let i = 0; i < tabSet.length; i++) {
        if (val.indexOf(tabSet[i]) != -1) {
          idx = i;
          console.log(222222, tabSet[i]);
          console.log(333333333333, idx);
          break;
        }
      }
      return idx;
    },
    checkPath(val) {
      let idx = this.getSetIndex(val);
      console.log("check idx", idx);
      this.$store.state.tabCur = idx;
      this.cur = this.$store.state.tabCur;
    },
    toPage(val) {
      this.$router.push(this.tabSet[val]);
      this.$store.dispatch("getNewTabCur", val);
    },
    tabEn() {
      this.$i18n.locale = "en";
    },
    tabCn() {
      this.$i18n.locale = "zh";
    },
    // hover
    homeOver(val) {  
    }
  }
};
</script>
<style scoped>
.topBanner {
  width: 100%;
  min-width: 900px;
  height: 37px;
  color: rgba(255, 255, 255, 1);
  position: absolute;
  z-index: 10;
  top: 34px;
}

.flex {
  display: flex;
}

.flexBox {
  flex-grow: 1;
  line-height: 37px;
}

.flexTwo {
  display: flex;
  text-align: center;
}

.flexChild {
  flex-grow: 1;
  text-align: center;
  cursor: pointer;
}

.floatBox::after {
  content: "";
  display: block;
  clear: both;
}

.floatLeft,
.floatCenter {
  float: left;
  height: 37px;
  line-height: 37px;
}

.floatRight {
  float: right;
  width: 22%;
}

.floatRight div {
  display: inline-block;
}

.leftText {
  height: 37px;
  line-height: 37px;
  margin-left: 7%;
  margin-right: 12%;
}

.floatCenter {
  width: 40%;
  font-size: 1.9rem;
}

.rightText {
  width: 96px;
  line-height: 29px;
  height: 29px;
  color: rgba(252, 200, 0, 1);
  border: 1px solid rgba(252, 200, 0, 1);
  margin-right: 15%;
  font-size: 1.9rem;
  text-align: center;
}

.rightLast {
  margin-right: 9%;
  font-size: 1.4rem;
}
.CNCss {
  cursor: pointer;
}
.leftIconImg{
  cursor: pointer;
}
.ENCss {
  color: rgba(128, 128, 128, 1);
  display: inline-block;
  margin-left: 13px;
  cursor: pointer;
}

.bottomLine {
  margin: auto;
  width: 40px;
  height: 2px;
  border-top: 2px solid rgba(252, 200, 0, 1);
}

.active {
  font-size: 2rem;
  font-weight: bold;
  flex-grow: 1;
}

.bottomLine1,
.bottomLine2,
.bottomLine3,
.bottomLine4,
.bottomLine5,
.bottomLine6,
.bottomLine7,
.bottomLine8 {
  margin: auto;
  width: 40px;
  height: 2px;
  border-top: 2px solid rgba(252, 200, 0, 1);
  transition: 0.3s;
  transform: scaleX(0);
}

.flexChild1,
.flexChild2,
.flexChild3,
.flexChild4,
.flexChild5,
.flexChild6,
.flexChild7,
.flexChild8 {
  position: relative;
}

.bottomLine,
.bottomLine1,
.bottomLine2,
.bottomLine3,
.bottomLine4,
.bottomLine5,
.bottomLine6,
.bottomLine7,
.bottomLine8 {
  position: absolute;
  bottom: -6px;
  left: calc(50% - 20px);
}

.flexChild1:hover .bottomLine1 {
  transform: scaleX(1);
}

.flexChild2:hover .bottomLine2 {
  transform: scaleX(1);
}

.flexChild3:hover .bottomLine3 {
  transform: scaleX(1);
}

.flexChild4:hover .bottomLine4 {
  transform: scaleX(1);
}

.flexChild5:hover .bottomLine5 {
  transform: scaleX(1);
}

.flexChild6:hover .bottomLine6 {
  transform: scaleX(1);
}

.flexChild7:hover .bottomLine7 {
  transform: scaleX(1);
}

.flexChild8:hover .bottomLine8 {
  transform: scaleX(1);
}
</style>



// WEBPACK FOOTER //
// src/components/top.vue